import db from "../../database";
import store from "../../store";
import * as msg from "../../message";

export const getSetting = (data) => {
  return new Promise((resolve, reject) => {
    let response = {
      data: {},
    };

    if (store.state.system.isOffline == false) {
      return Promise.resolve(response);
    }

    db.transaction("rw", db.setting, async () => {
      db.setting
        .where("user_id")
        .equals(parseInt(data.vu_id))
        .first()
        .then((item) => {
          response.data = {
            settings: item.settings,
          };
        });
    })
      .then(() => {
        resolve(response);
      })
      .catch((err) => {
        store.dispatch("system/log", {
          type: "settings",
          log: { name: err.name, message: err.message },
          response: err.stack,
          status: "error",
        });
        alertData();
        reject(response);
      });
  });
};

function alertData() {
  let alertData = {
    message: msg.INTERNAL_SERVER_ERROR,
    type: "danger",
  };
  store.commit("notifications/showAlert", alertData);
}
